import { useRoute } from 'vue-router';

import { computed } from 'vue';
import { MenuResource } from '@menu/Types/Resources/MenuResource';
import { trans } from '@menu/Utils/i18n';
import getRestaurant from '@menu/Utils/getRestaurant';
import getMenuBySlug from '@menu/Utils/getMenuBySlug';

export const useCurrentMenu = () => {
  const route = useRoute();
  const restaurant = getRestaurant();

  const menu = computed<MenuResource>(() =>
    getMenuBySlug(route.params['menuSlug'] as string),
  );

  const availableCategoryTypes = computed<{ name: string; slug: string }[]>(
    () => {
      return (
        restaurant.slug === 'saya-brasserie-cafe'
          ? [
              {
                name: trans('Food'),
                slug: 'food',
              },
              {
                name: trans('Desserts'),
                slug: 'desserts',
              },
              {
                name: trans('Drinks'),
                slug: 'drinks',
              },
              {
                name: trans('Shisha'),
                slug: 'shisha',
              },
              {
                name: trans('Offers'),
                slug: 'offers',
              },
            ]
          : [
              {
                name: trans('Food'),
                slug: 'food',
              },
              {
                name: trans('Drinks'),
                slug: 'drinks',
              },
              {
                name: trans('Desserts'),
                slug: 'desserts',
              },
              {
                name: trans('Shisha'),
                slug: 'shisha',
              },
              {
                name: trans('Offers'),
                slug: 'offers',
              },
            ]
      ).filter((categoryType) => {
        return menu.value.categories.some((category) => {
          return category.type === categoryType.slug;
        });
      });
    },
  );

  return {
    menu,
    availableCategoryTypes,
  };
};
